// extracted by mini-css-extract-plugin
module.exports = {"root":"noticeBoard_root__2hGgI","tableHead":"noticeBoard_tableHead__1AOGo"};